import {
  GetProposalQuery,
  SetProposalContentSectionInput,
} from '@/gql/graphql';
import { produce } from 'immer';

export const applyProposalContentSection = (
  data: GetProposalQuery,
  input: SetProposalContentSectionInput
): GetProposalQuery =>
  produce(data, (draft) => {
    for (const section of draft.proposal.sections) {
      if (
        section.__typename === 'ProposalContentSection' &&
        section.key === input.sectionKey
      ) {
        section.content = input.content;
        return;
      }
    }
  });
